import React from "react"

import { MobileNavigation, KioskNavigation } from "components/navigation"
import { matchPath, useLocation } from "react-router-dom"
import config from "config"
import { useAppUI } from "providers/ui"

export const AppNavigation = () => {
  const location = useLocation()
  const {
    showBottomNavigation,
    mobileNavigations,
    mobileMainNavigations,
    kioskNavigation,
    navigations,
  } = useAppUI()
  const device = config("device") || "mobile"

  /** Find matched path to add "select" state to navs
   *  - add /* so that all sub-pages will match too, (eg. /maps/ordinal/1, /maps/place/:placeId will also set `/maps` to selected)
   */

  const matchedPath = navigations?.find((nav) =>
    matchPath(`${nav.to}/*`, location.pathname)
  )

  switch (device) {
    case "kiosk-v":
    case "kiosk-h":
      return (
        <KioskNavigation
          value={matchedPath?.to}
          navigations={kioskNavigation}
          show={showBottomNavigation}
        />
      )
    case "mobile":
    default:
      return (
        <MobileNavigation
          value={matchedPath?.to}
          bottomNavigations={mobileMainNavigations}
          navigations={mobileNavigations}
          show={showBottomNavigation}
        />
      )
  }
}
